import { defineMessages } from 'react-intl';

export default defineMessages({
  productType_all_plural: {
    id: 'app.productType.all',
    defaultMessage: 'All products',
  },
  productType_business_card_singular: {
    id: 'app.productType.business_card.singular',
    defaultMessage: 'Business Card',
  },
  productType_business_card_foil_singular: {
    id: 'app.productType.business_card_foil.singular',
    defaultMessage: 'Business Card + Foil or Gloss',
  },
  productType_sticker_singular: {
    id: 'app.productType.sticker.singular',
    defaultMessage: 'Sticker',
  },
  productType_notecard_singular: {
    id: 'app.productType.notecard.singular',
    defaultMessage: 'Notecard',
  },
  productType_letterhead_singular: {
    id: 'app.productType.letterhead.singular',
    defaultMessage: 'Letterhead',
  },
  productType_postcard_singular: {
    id: 'app.productType.postcard.singular',
    defaultMessage: 'Postcard',
  },
  productType_flyer_singular: {
    id: 'app.productType.flyer.singular',
    defaultMessage: 'Flyer',
  },
  productType_business_card_plural: {
    id: 'app.productType.business_card.plural',
    defaultMessage: 'Business Cards',
  },
  productType_all_moo_products_plural: {
    id: 'app.productType.all_moo_products.plural',
    defaultMessage: 'All MOO Products',
  },
  productType_notebook_plural: {
    id: 'app.productType.notebook.plural',
    defaultMessage: 'Notebooks',
  },
  productType_envelope_plural: {
    id: 'app.productType.envelope.plural',
    defaultMessage: 'Envelopes',
  },
  productType_business_card_holder_plural: {
    id: 'app.productType.business_card_holder.plural',
    defaultMessage: 'Business Card Holders',
  },
  productType_whitelabel_packaging_singular: {
    id: 'app.productType.whitelabel_packaging.singular',
    defaultMessage: 'WhiteLabel Packaging',
  },
  productType_whitelabel_packaging_plural: {
    id: 'app.productType.whitelabel_packaging.plural',
    defaultMessage: 'WhiteLabel Packaging',
  },
  productType_drinkware_singular: {
    id: 'app.productType.drinkware.singular',
    defaultMessage: 'Drinkware',
  },
  productType_drinkware_plural: {
    id: 'app.productType.drinkware.plural',
    defaultMessage: 'Drinkware',
  },
  productType_perpetual_plannner_singular: {
    id: 'app.productType.perpetual_planner.singular',
    defaultMessage: 'Perpetual Planner',
  },
  productType_perpetual_planner_plural: {
    id: 'app.productType.perpetual_planner.plural',
    defaultMessage: 'Perpetual Planners',
  },
  productType_other_singular: {
    id: 'app.productType.other.singular',
    defaultMessage: 'Other',
  },
  productType_other_plural: {
    id: 'app.productType.other.plural',
    defaultMessage: 'Other',
  },
  productType_holidaycard_singular: {
    id: 'app.productType.holidaycard.singular',
    defaultMessage: 'Greeting Card',
  },
  productType_holidaycard_plural: {
    id: 'app.productType.holidaycard.plural',
    defaultMessage: 'Greeting Cards',
  },
  productType_business_card_foil_plural: {
    id: 'app.productType.business_card_foil.plural',
    defaultMessage: 'Business Card + Foil or Gloss',
  },
  productType_sticker_plural: {
    id: 'app.productType.sticker.plural',
    defaultMessage: 'Stickers',
  },
  productType_notecard_plural: {
    id: 'app.productType.notecard.plural',
    defaultMessage: 'Notecards',
  },
  productType_letterhead_plural: {
    id: 'app.productType.letterhead.plural',
    defaultMessage: 'Letterheads',
  },
  productType_postcard_plural: {
    id: 'app.productType.postcard.plural',
    defaultMessage: 'Postcards',
  },
  productType_flyer_plural: {
    id: 'app.productType.flyer.plural',
    defaultMessage: 'Flyers',
  },
  productSize_businesscard: {
    id: 'app.productSize.business_card.businesscard',
    defaultMessage: 'Business Cards',
  },
  productSize_holidaycard: {
    id: 'app.productSize.holidaycard.holidaycard',
    defaultMessage: 'Greeting Cards',
  },
  productSize_holidaycard_plural: {
    id: 'app.productSize.holidaycard.holidaycard',
    defaultMessage: 'Greeting Cards',
  },
  productSize_holidaycard_singular: {
    id: 'app.productSize.holidaycard.holidaycard',
    defaultMessage: 'Greeting Cards',
  },
  productSize_businesscard_square: {
    id: 'app.productSize.business_card.businesscard_square',
    defaultMessage: 'Square business cards',
  },
  productSize_businesscard_us: {
    id: 'app.productSize.business_card.businesscard_us',
    defaultMessage: 'US business cards',
  },
  productSize_foil_fake_id: {
    id: 'app.productSize.business_card_foil.fake_id',
    defaultMessage: 'Fake type for foil cards',
  },
  productSize_minicard: {
    id: 'app.productSize.business_card.minicard',
    defaultMessage: 'Minicard',
  },
  productSize_postcard: {
    id: 'app.productSize.postcard.postcard',
    defaultMessage: 'Postcards',
  },
  productSize_postcard_medium: {
    id: 'app.productSize.postcard.postcard_medium',
    defaultMessage: 'Medium Postcards',
  },
  productSize_postcard_square: {
    id: 'app.productSize.postcard.postcard_square',
    defaultMessage: 'Square Postcards',
  },
  productSize_postcard_dl_us: {
    id: 'app.productSize.postcard.postcard_dl_us',
    defaultMessage: 'Rack Cards',
  },
  productSize_postcard_dl: {
    id: 'app.productSize.postcard.postcard_dl',
    defaultMessage: 'DL postcards',
  },
  productSize_postcard_half_page_us: {
    id: 'app.productSize.postcard.postcard_half_page_us',
    defaultMessage: 'Half Page Postcards',
  },
  productSize_postcard_large: {
    id: 'app.productSize.postcard.postcard_large',
    defaultMessage: 'Large Postcards',
  },
  productSize_postcard_a5: {
    id: 'app.productSize.postcard.postcard_a5',
    defaultMessage: 'A5 Postcards',
  },
  productSize_postcard_standard: {
    id: 'app.productSize.postcard.postcard_standard',
    defaultMessage: 'Standard Postcards',
  },
  productSize_letterhead_a4: {
    id: 'app.productSize.letterhead.letterhead_a4',
    defaultMessage: 'A4 letterheads',
  },
  productSize_letterhead_us_letter: {
    id: 'app.productSize.letterhead.letterhead_us_letter',
    defaultMessage: 'US letterheads',
  },
  productSize_notecard: {
    id: 'app.productSize.notecard.notecard',
    defaultMessage: 'Notecard',
  },
  productSize_sticker: {
    id: 'app.productSize.sticker.sticker',
    defaultMessage: 'StickerBooks',
  },
  productSize_sticker_round: {
    id: 'app.productSize.sticker.sticker_round',
    defaultMessage: 'Round stickers',
  },
  productSize_sticker_label: {
    id: 'app.productSize.sticker.sticker_label',
    defaultMessage: 'Rectangular stickers',
  },
  productSize_return_address_labels: {
    id: 'app.productSize.sticker.return_address_labels',
    defaultMessage: 'Return address labels',
  },
  productSize_sticker_large_rectangular: {
    id: 'app.productSize.sticker.large_rectangular',
    defaultMessage: 'Large rectangular stickers',
  },
  productSize_sticker_large_round: {
    id: 'app.productSize.sticker.large_round',
    defaultMessage: 'Large round stickers',
  },
  productSize_flyer_a4: {
    id: 'app.productSize.flyer.flyer_a4',
    defaultMessage: 'A4 flyers',
  },
  productSize_flyer_dl: {
    id: 'app.productSize.flyer.flyer_dl',
    defaultMessage: 'DL flyers',
  },
  productSize_flyer_a5: {
    id: 'app.productSize.flyer.flyer_a5',
    defaultMessage: 'A5 flyers',
  },
  productSize_flyer_a6: {
    id: 'app.productSize.flyer.flyer_a6',
    defaultMessage: 'A6 flyers',
  },
  productSize_flyer_square: {
    id: 'app.productSize.flyer.flyer_square',
    defaultMessage: 'Square flyers',
  },
  productSize_flyer_half_page_us: {
    id: 'app.productSize.flyer.flyer_half_page_us',
    defaultMessage: 'Half page flyers',
  },
  productSize_flyer_us_letter: {
    id: 'app.productSize.flyer.flyer_us_letter',
    defaultMessage: 'US letter flyers',
  },
  productSize_flyer_dl_us: {
    id: 'app.productSize.flyer.flyer_dl_us',
    defaultMessage: 'Rack cards',
  },
  productSize_businesscard_singular: {
    id: 'app.productSize.business_card.businesscard.singular',
    defaultMessage: 'MOO Size Business Card',
  },
  productSize_businesscard_square_singular: {
    id: 'app.productSize.business_card.businesscard_square.singular',
    defaultMessage: 'Square Business Card',
  },
  productSize_businesscard_us_singular: {
    id: 'app.productSize.business_card.businesscard_us.singular',
    defaultMessage: 'Standard Business Card',
  },
  productSize_minicard_singular: {
    id: 'app.productSize.business_card.minicard.singular',
    defaultMessage: 'Mini Business Card',
  },
  productSize_businesscard_plural: {
    id: 'app.productSize.business_card.businesscard.plural',
    defaultMessage: 'MOO Size Business Cards',
  },
  productSize_businesscard_square_plural: {
    id: 'app.productSize.business_card.businesscard_square.plural',
    defaultMessage: 'Square Business Cards',
  },
  productSize_businesscard_us_plural: {
    id: 'app.productSize.business_card.businesscard_us.plural',
    defaultMessage: 'Standard Business Cards',
  },
  productSize_minicard_plural: {
    id: 'app.productSize.business_card.minicard.plural',
    defaultMessage: 'Mini Business Cards',
  },
  productSize_foil_fake_id_singular: {
    id: 'app.productSize.business_card_foil.fake_id.singular',
    defaultMessage: 'Fake type for foil card',
  },
  productSize_postcard_singular: {
    id: 'app.productSize.postcard.postcard.singular',
    defaultMessage: 'postcard',
  },
  productSize_postcard_medium_singular: {
    id: 'app.productSize.postcard.postcard_medium.singular',
    defaultMessage: 'medium postcard',
  },
  productSize_postcard_square_singular: {
    id: 'app.productSize.postcard.postcard_square.singular',
    defaultMessage: 'square postcard',
  },
  productSize_postcard_dl_us_singular: {
    id: 'app.productSize.postcard.postcard_dl_us.singular',
    defaultMessage: 'rack card',
  },
  productSize_postcard_dl_singular: {
    id: 'app.productSize.postcard.postcard_dl.singular',
    defaultMessage: 'DL postcard',
  },
  productSize_postcard_half_page_us_singular: {
    id: 'app.productSize.postcard.postcard_half_page_us.singular',
    defaultMessage: 'half page postcard',
  },
  productSize_postcard_large_singular: {
    id: 'app.productSize.postcard.postcard_large.singular',
    defaultMessage: 'large postcard',
  },
  productSize_postcard_a5_singular: {
    id: 'app.productSize.postcard.postcard_a5.singular',
    defaultMessage: 'A5 postcard',
  },
  productSize_postcard_standard_singular: {
    id: 'app.productSize.postcard.postcard_standard.singular',
    defaultMessage: 'standard postcard',
  },
  productSize_letterhead_a4_singular: {
    id: 'app.productSize.letterhead.letterhead_a4.singular',
    defaultMessage: 'A4 letterhead',
  },
  productSize_letterhead_us_letter_singular: {
    id: 'app.productSize.letterhead.letterhead_us_letter.singular',
    defaultMessage: 'US letterhead',
  },
  productSize_notecard_singular: {
    id: 'app.productSize.notecard.notecard.singular',
    defaultMessage: 'notecard',
  },
  productSize_sticker_singular: {
    id: 'app.productSize.sticker.sticker.singular',
    defaultMessage: 'stickerBook',
  },
  productSize_sticker_plural: {
    id: 'app.productSize.sticker.sticker.plural',
    defaultMessage: 'stickerBooks',
  },
  productSize_sticker_round_singular: {
    id: 'app.productSize.sticker.sticker_round.singular',
    defaultMessage: 'round sticker',
  },
  productSize_return_address_labels_singular: {
    id: 'app.productSize.sticker.return_address_labels.singular',
    defaultMessage: 'Return address label',
  },
  productSize_sticker_large_rectangular_singular: {
    id: 'app.productSize.sticker.large_rectangular.singular',
    defaultMessage: 'Large rectangular stickers',
  },
  productSize_sticker_large_round_singular: {
    id: 'app.productSize.sticker.large_round.singular',
    defaultMessage: 'Large round sticker',
  },
  productSize_sticker_return_address_labels_plural: {
    id: 'app.productSize.sticker.return_address_labels',
    defaultMessage: 'Return address labels',
  },
  productSize_sticker_large_rectangular_plural: {
    id: 'app.productSize.sticker.large_rectangular',
    defaultMessage: 'Large rectangular stickers',
  },
  productSize_sticker_large_round_plural: {
    id: 'app.productSize.sticker.large_round',
    defaultMessage: 'Large round stickers',
  },
  productSize_sticker_round_plural: {
    id: 'app.productSize.sticker.sticker_round.plural',
    defaultMessage: 'round stickers',
  },
  productSize_sticker_label_singular: {
    id: 'app.productSize.sticker.sticker_label.singular',
    defaultMessage: 'rectangular sticker',
  },
  productSize_sticker_label_plural: {
    id: 'app.productSize.sticker.sticker_label.plural',
    defaultMessage: 'rectangular stickers',
  },
  productSize_flyer_a4_singular: {
    id: 'app.productSize.flyer.flyer_a4.singular',
    defaultMessage: 'A4 flyer',
  },
  productSize_flyer_a4_plural: {
    id: 'app.productSize.flyer.flyer_a4.plural',
    defaultMessage: 'A4 flyers',
  },
  productSize_flyer_dl_singular: {
    id: 'app.productSize.flyer.flyer_dl.singular',
    defaultMessage: 'DL flyer',
  },
  productSize_flyer_dl_plural: {
    id: 'app.productSize.flyer.flyer_dl.plural',
    defaultMessage: 'DL flyers',
  },
  productSize_flyer_a5_singular: {
    id: 'app.productSize.flyer.flyer_a5.singular',
    defaultMessage: 'A5 flyer',
  },
  productSize_flyer_a5_plural: {
    id: 'app.productSize.flyer.flyer_a5.plural',
    defaultMessage: 'A5 flyers',
  },
  productSize_flyer_a6_singular: {
    id: 'app.productSize.flyer.flyer_a6.singular',
    defaultMessage: 'A6 flyer',
  },
  productSize_flyer_a6_plural: {
    id: 'app.productSize.flyer.flyer_a6.plural',
    defaultMessage: 'A6 flyers',
  },
  productSize_flyer_square_singular: {
    id: 'app.productSize.flyer.flyer_square.singular',
    defaultMessage: 'square flyer',
  },
  productSize_flyer_square_plural: {
    id: 'app.productSize.flyer.flyer_square.plural',
    defaultMessage: 'square flyers',
  },
  productSize_flyer_half_page_us_singular: {
    id: 'app.productSize.flyer.flyer_half_page_us.singular',
    defaultMessage: 'half page flyer',
  },
  productSize_flyer_half_page_us_plural: {
    id: 'app.productSize.flyer.flyer_half_page_us.plural',
    defaultMessage: 'half page flyers',
  },
  productSize_flyer_us_letter_singular: {
    id: 'app.productSize.flyer.flyer_us_letter.singular',
    defaultMessage: 'US letter flyer',
  },
  productSize_flyer_us_letter_plural: {
    id: 'app.productSize.flyer.flyer_us_letter.plural',
    defaultMessage: 'US letter flyers',
  },
  productSize_flyer_dl_us_singular: {
    id: 'app.productSize.flyer.flyer_dl_us.singular',
    defaultMessage: 'rack card',
  },
  productSize_flyer_dl_us_plural: {
    id: 'app.productSize.flyer.flyer_dl_us.plural',
    defaultMessage: 'rack cards',
  },
});
